import { Component, Input, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { NgForm } from '@angular/forms';

import { FormsUtilsService, MessageService, notCloseMessageOptions } from '../../../../core';
import { Classificavel, ClassificacaoSelectComponent } from '../../../classificacao';
import { GrupoClassificacaoClassificacao } from '../../classificacao';

@Component({
    selector: 'sgt-grupo-classificacao-classificavel-form',
    templateUrl: './grupo-classificacao-classificavel-form.component.html',
    styleUrls: ['./grupo-classificacao-classificavel-form.component.less']
})
export class GrupoClassificacaoClassificavelFormComponent {
    /** Se pode editar as classificações */
    @Input() canEdit = true;

    /** Classificações */
    @Input() entities: Classificavel[];

    /** Se deve obrigar a seleção das classificações conforme a hierarquia definida, ou seja, se uma classificação tiver um classificação pai, deve ser possível selecionar classificações abaixo desta pai */
    @Input() obrigarHierarquia = true;

    /** Se deve filtrar somente as classificações ativias */
    @Input() somenteClassificacoesAtivas = false;

    @ViewChild('form') form: NgForm;
    /** Selects das classificações */
    @ViewChildren('classificacaoSelect') classificacaoSelects: QueryList<ClassificacaoSelectComponent>;

    constructor(private formsUtilsService: FormsUtilsService,
                private messageService: MessageService) { }

    /** Insere uma classificação através da classificação do grupo */
    insertClassificacao(entityClassificavel: Classificavel, grupoClassificacaoClassificacao: GrupoClassificacaoClassificacao) {
        if (!entityClassificavel || !grupoClassificacaoClassificacao) {
            return;
        }

        entityClassificavel.idTipoClassificacao = grupoClassificacaoClassificacao.idTipoClassificacao;
        entityClassificavel.tipoClassificacao = grupoClassificacaoClassificacao.tipoClassificacao;
        entityClassificavel.idClassificacao = grupoClassificacaoClassificacao.idClassificacao;
        entityClassificavel.classificacao = grupoClassificacaoClassificacao.classificacao;
        entityClassificavel.canEdit = !grupoClassificacaoClassificacao.idClassificacao; // Somente pode editar se não possuir a classificação explicitamente informada no grupo
        entityClassificavel.obrigatorio = grupoClassificacaoClassificacao.obrigatorio;
    }

    /** Limpa a classificação para a entidade informada */
    private clearClassificacao(entity: Classificavel) {
        if (!entity) {
            return;
        }

        entity.idClassificacao = null;
        entity.classificacao = null;
    }

    /** Ao alterar a classificação */
    onChangeClassificacao(indexClassificacaoChanged: number) {
        // Limpando todas as classificações de nível abaixo da classificação alterada
        for (let i = this.entities?.length; i--;) {
            if (i > indexClassificacaoChanged) {
                const entity = this.entities[i];
                if (entity.canEdit) { // Somente classificações que podem ser editáveis
                    this.clearClassificacao(entity)
                }
            }
        }
    }

    /** Verifica as classificações estão válidas */
    isValid(): boolean {
        this.formsUtilsService.makeAllFieldsDirty(this.form);

        // Duplicações
        for (let i = 0; i < this.entities.length; i++) {
            const entity = this.entities[i];

            // Classificação
            if (entity.obrigatorio && !entity.idClassificacao) {
                this.messageService.warning('É necessário selecionar o segmento', 'Atenção', notCloseMessageOptions);
                this.classificacaoSelects?.toArray()[i]?.setFocus();
                return false;
            }
            // Classificação duplicada
            const countClassificacao = this.entities.filter(entityFilter => entityFilter.idClassificacao && entityFilter.idClassificacao === entity.idClassificacao).length;
            if (countClassificacao > 1) {
                this.messageService.warning(`O segmento ${entity?.classificacao?.nome} já está adicionado. Altere o segmento duplicado`, 'Não é possível adicionar dois segmentos iguais', notCloseMessageOptions);
                this.classificacaoSelects?.toArray()[i]?.setFocus();
                return false;
            }
        }

        // Form
        if (this.form.invalid) {
            this.messageService.warning('Preencha corretamente os segmentos', 'Atenção', notCloseMessageOptions);
            return false;
        }

        return true;
    }
}
